// third party
import { SnackbarProvider } from 'notistack';

// assets
import { IconCircleCheck, IconSquareRoundedX, IconInfoCircle, IconAlertCircle } from '@tabler/icons-react';

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

export default function Notistack({ children }: any) {
  const iconSX = { marginRight: 8, fontSize: '1.15rem' };

  return (
    <SnackbarProvider
      maxSnack={3}
      dense={false}
      iconVariant={{
        success: <IconCircleCheck style={iconSX} />,
        error: <IconSquareRoundedX style={iconSX} />,
        warning: <IconInfoCircle style={iconSX} />,
        info: <IconAlertCircle style={iconSX} />
      }}
    >
      {children}
    </SnackbarProvider>
  );
}
